module.exports = __webpack_public_path__ + "2deae4fb83509cac87bdc29ebeedd1be.svg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../components/Footer/logos/sturken.svg
// module id = 946
// module chunks = 0